import React from 'react';
import { ArrowRight } from 'lucide-react';
import useCountUp from '../../../../hooks/useCountUp';

const parseNumber = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    const str = String(value).replace(/[^0-9.-]/g, '');
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
};

const LandingCard = ({ title, description, metric, metricUnit, icon: Icon, onClick, delay = 0 }) => {
    const numericValue = parseNumber(metric);
    const { count } = useCountUp(numericValue || 0, 1000, numericValue !== null);

    const displayMetric = numericValue !== null ? count : metric;

    return (
        <button
            onClick={onClick}
            className="clinic-dashboard-card"
            style={{ animationDelay: `${delay}ms` }}
        >
            <div className="clinic-dashboard-card-top">
                <div className="clinic-dashboard-card-icon">
                    <Icon size={24} />
                </div>
                <div className="clinic-dashboard-card-arrow">
                    <ArrowRight size={20} />
                </div>
            </div>
            <div>
                <div className="clinic-dashboard-card-title">{title}</div>
                <div className="clinic-dashboard-card-desc">{description}</div>
            </div>
            <div>
                <span className="clinic-dashboard-card-metric">{displayMetric}</span>
                <span className="clinic-dashboard-card-metric-unit">{metricUnit}</span>
            </div>
        </button>
    );
};

export default LandingCard;
